import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { getMe, login as apiLogin, loginKey as apiLoginKey, logoutSession } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=none, obj=auth
  const [ready, setReady] = useState(false);

  useEffect(() => {
    localStorage.removeItem("hv_token");
    getMe()
      .then((u) => setUser(u))
      .catch(() => setUser(false))
      .finally(() => setReady(true));
  }, []);

  const login = useCallback(async (email, password) => {
    const data = await apiLogin(email, password);
    setUser(data.user);
    return data.user;
  }, []);

  const loginWithKey = useCallback(async (key, captchaToken, captchaAnswer) => {
    const data = await apiLoginKey(key, captchaToken, captchaAnswer);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    logoutSession().catch((e) => console.error("Logout failed", e));
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, ready, login, loginWithKey, logout }), [user, ready, login, loginWithKey, logout]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
